function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { MessageDirection, wrap } from "./shared";
const debug = (...args)=>{
    console.log(...args);
};
export const buildWebKitTransport = ()=>{
    return new WebKitTransport();
};
class WebKitTransport {
    postMessage(messages) {
        debug("attempting to send", messages);
        let anyWindow = window;
        debug("window.webkit", anyWindow.webkit);
        const wrappedOutgoingMessage = wrap(messages, MessageDirection.FromPaywall);
        debug("wrapped message", wrappedOutgoingMessage);
        if (anyWindow.webkit && anyWindow.webkit.messageHandlers && anyWindow.webkit.messageHandlers.paywallMessageHandler) {
            debug("window.webkit.messageHandlers.paywallMessageHandler set!");
            anyWindow.webkit.messageHandlers.paywallMessageHandler.postMessage(wrappedOutgoingMessage);
            return;
        }
        debug("unable to send message");
    }
    addListener(handler) {
        this._handlers.push(handler);
    }
    startListening() {
        this._listening = true;
    }
    accept(message) {
        if (this._listening) {
            this._handlers.forEach((handler)=>handler(message));
        }
    }
    constructor(){
        _define_property(this, "_handlers", []);
        _define_property(this, "_listening", false);
    }
}
